import { IClient } from "..";
import {
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconTelegram,
  IconTiktok,
  IconX,
  IconYoutube,
  LogoUnderblock,
  LogoUnderblockColor,
} from "../../assets";

export const Underblock: IClient = {
  colors: {
    primary: [
      "#3032A3", //0
      "#041233", //1
      "#041233", //2
      "#041233", //3
      "#041233", //4
    ],
    primaryOpacity: [
      "#EAF0FC", //0
      "#EBEEFA", //1
      "#EBEEFA", //2
      "#EBEEFA", //3
      "#EBEEFA", //4
    ],
    complementary: [
      "#169C3C", //0
      "#2C1B73", //1
      "#E3183B", //2
      "#8131E6", //3
      "#FB6815", //4
      "#EB49EE", //5
      "#319CE6", //6
      "#5E71D7", //7
    ],
    complementaryOpacity: [
      "#E8F5EC", //0
      "#EAE8F1", //1
      "#FCE8EB", //2
      "#F2EAFC", //3
      "#FFEEDE", //4
      "#FDEDFD", //5
      "#EAF5FC", //6
      "#EAF0FC", //7
    ],
    basic: [
      "#FFFFFF", //0
      "#F0F0F0", //1
      "#D7D7D7", //2
      "#B2B1B1", //3
      "#6B6B6B", //4
      "#2F2F2F", //5
    ],
    other: [
      "#FAFBFE", //0
      "#B9B9B9", //1
      "#3032A3", //2
      "#020B12", //3
      "#DEDEDE", //4
      "#B3B1B1", //5
    ],
    alerts: [
      "#F43333", //0
      "#FAAB36", //1
      "#23BD32", //2
      "#EB4747", //3
    ],
    alertsOpacity: [
      "#FEEBEB", //0
      "#FEF7EB", //1
      "#E9F8EB", //2
    ],
  },
  image: {
    logo: LogoUnderblock,
    icon: LogoUnderblock,
    logo2: LogoUnderblockColor,
    icon2: LogoUnderblockColor,
  },
  name: "Underblock",
  title: "Underblock",
  favicon: "favicon-underblock.ico",
  description:
    "Underblock - Plataforma de investimentos e gestão de portfólio. Acesse estratégias exclusivas e operações automatizadas.",
  acceptLanguage: ["pt-BR", "en-US", "es"],
  autoRegister: false,
  hasBrokers: false,
  hasCancelButton: false,
  hasClarity: false,
  hasFinancial: false,
  redirect: "/meu-portfolio/minhas-compras",
  email: {
    email: "global.footer.email",
    link: "https://Underblockhelp.zendesk.com/hc/pt-br",
  },
  terms: {
    pt_br: "https://spidertrader.com.br/termo-de-uso-do-site-e-aplicativos/",
    en_us: "https://spidertrader.com.br/en/terms-of-use/",
    es: "https://spidertrader.com.br/es/condiciones-de-uso/",
  },
  privacyPolicy: {
    pt_br:
      "https://spidertrader.com.br/politica-de-privacidade-de-dados-pessoais",
    en_us: "https://spidertrader.com.br/en/privacy-policy/",
    es: "https://spidertrader.com.br/es/politica-de-privacidad-de-datos-personales/",
  },
  contacts: [
    {
      name: "A Underblock foi criada com o objetivo de descomplicar o mercado de criptomoedas e trazer aos investidores brasileiros somente as melhores oportunidades desse setor.",
      contact: "",
      contactText: "",
      description: "",
    },
  ],
  footerLinksTerms: [
    {
      path: {
        pt_br:
          "https://spidertrader.com.br/politica-de-privacidade-de-dados-pessoais",
        en_us: "https://spidertrader.com.br/en/privacy-policy/",
        es: "https://spidertrader.com.br/es/politica-de-privacidad-de-datos-personales/",
      },
      name: "global.routes_names.privacy_policy",
    },
    {
      path: {
        pt_br:
          "https://spidertrader.com.br/termo-de-uso-do-site-e-aplicativos/",
        en_us: "https://spidertrader.com.br/en/terms-of-use/",
        es: "https://spidertrader.com.br/es/condiciones-de-uso/",
      },
      name: "global.routes_names.terms_of_use",
    },
    {
      path: {
        pt_br: "https://Underblockhelp.zendesk.com/hc/pt-br",
        en_us: "https://Underblockhelp.zendesk.com/hc/en",
        es: "https://Underblockhelp.zendesk.com/hc/es",
      },
      name: "global.routes_names.help_center",
    },
  ],
  navbarLinksDefault: [
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_purchases",
          path: "/meu-portfolio/minhas-compras",
        },
      ],
    },
  ],
  navbarLinksClient: [
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_purchases",
          path: "/meu-portfolio/minhas-compras",
        },
      ],
    },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        {
          name: "global.routes_names.operations_performance",
          path: "/operacoes/desempenho",
        },
        {
          name: "global.routes_names.operations_positions",
          path: "/operacoes/posicoes",
        },
        {
          name: "global.routes_names.operations_orders",
          path: "/operacoes/ordens",
        },
      ],
    },
  ],
  navbarLinksAnalyst: [
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_products",
          path: "/meu-portfolio/meus-servicos",
        },
      ],
    },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        // {
        //   name: "global.routes_names.operations_performance",
        //   path: "/operacoes/desempenho",
        // },
        {
          name: "global.routes_names.operations_positions",
          path: "/operacoes/posicoes",
        },
        {
          name: "global.routes_names.operations_orders",
          path: "/operacoes/ordens",
        },
      ],
    },
  ],
  socialLinks: [
    {
      path: "https://instagram.com/underblock.crypto",
      icon: IconInstagram,
      name: "Instagram",
    },
    {
      path: "https://www.youtube.com/@underblock.crypto",
      icon: IconYoutube,
      name: "Youtube",
    },
    {
      path: "https://www.linkedin.com/company/underblock/about/",
      icon: IconLinkedin,
      name: "Linkedin",
    },
    {
      path: "https://t.me/comunidade_underblock",
      icon: IconTelegram,
      name: "Telegram",
    },
  ],
};
